import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import parse from "html-react-parser";
import * as React from "react";
import { css } from "styled-components";

const enum fields {
    text = "text",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.text]: string;
    };
    editAlertStyles: InjectableCss;
}

export type Props = OwnProps;

export interface EditOrderAlertStyles {
    editAlertWrapper?: InjectableCss;
}

export const EditOrderAlertStyles: EditOrderAlertStyles = {
    editAlertWrapper: {
        css: css`
            width: 100%;
            max-width: 450px;
            border-radius: 4px;
            border: 1px solid ${getColor("common.border")};
            margin-bottom: 30px;
            padding: 8px 16px;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            ${mediaQueriesBP.maxMD} {
                width: calc(100vw - 30px);
                max-width: unset;
                margin-top: 14px;
                margin-bottom: 14px;
            }

            p,
            span {
                margin: 0;
                font-size: 18px;

                ${mediaQueriesBP.maxMD} {
                    font-size: 16px;
                }

                a {
                    font-size: 18px;

                    ${mediaQueriesBP.maxMD} {
                        font-size: 16px;
                    }

                    span {
                        font-size: 18px;
                        margin-top: -3px;
                        display: inline-block;
                    }
                }
            }

            &::before {
                display: inline-block;
                background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M16.7891 2.53516L15.4443 1.19922L16.0684 0.583984C16.3848 0.267578 16.8857 0.223633 17.1846 0.513672L17.4131 0.750977C17.7471 1.07617 17.7383 1.55957 17.3955 1.91113L16.7891 2.53516ZM6.30371 11.9834C6.10156 12.0625 5.88184 11.834 5.96973 11.6318L6.76074 9.90039L14.7764 1.87598L16.1123 3.20312L8.09668 11.2275L6.30371 11.9834ZM2.98145 17.8457C1.0918 17.8457 0.0986328 16.8789 0.0986328 14.998V4.91699C0.0986328 3.03613 1.0918 2.06055 2.98145 2.06055H12.3242L10.6016 3.7832H3.08691C2.26953 3.7832 1.82129 4.21387 1.82129 5.06641V14.8486C1.82129 15.7012 2.26953 16.1318 3.08691 16.1318H13.124C13.7129 16.1318 14.1699 15.7012 14.1699 14.8486V7.43066L15.8926 5.70801V14.998C15.8926 16.8701 14.9082 17.8457 13.2295 17.8457H2.98145Z" fill="%230AA7D5"/></svg>');
                content: "";
                width: 18px;
                height: 18px;
                margin-right: 10px;
                background-size: 100%;
                background-repeat: no-repeat;
                flex-shrink: 0;
            }
        `,
    },
};

export const styles = EditOrderAlertStyles;

export const EditOrderAlert = ({ fields }: Props) => {
    return (
        fields.text && (
            <StyledWrapper {...styles.editAlertWrapper}>
                <Typography data-test-selector="edit_Alert">{parse(fields.text, parserOptions)}</Typography>
            </StyledWrapper>
        )
    );
};

const widgetModule: WidgetModule = {
    component: EditOrderAlert as any,
    definition: {
        displayName: "Edit Order Alert",
        icon: "edit",
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage"],
        group: "Order Details",
        fieldDefinitions: [
            {
                name: fields.text,
                fieldType: "General",
                editorTemplate: "RichTextField",
                displayName: "Content",
                defaultValue: "Edit Order Alert",
                extendedConfig: { height: 100 },
                expandedToolbarButtons: {
                    moreMisc: {
                        buttons: ["insertLink"],
                        buttonsVisible: 1,
                    },
                    code: {},
                },
            },
        ],
    },
};

export default widgetModule;
